import { app } from '../../app.module'
/**
 * アカウントの対象情報の取得のサービス
 * @return {Object} オブジェクト
 */
function AccountTargetData() {
  /**
   * setTargetTitle アカウントの対象名をセット
   * @param {string} targetTitle 対象名
   * @param {string} snsType snsタイプ
   * @return {string} 対象名
   */
  function setTargetTitle(targetTitle, snsType) {
    let title = ''

    switch (targetTitle) {
      case 'type':
        title = 'タイプ名'
        break
      case 'hashtag':
        if (snsType !== 'youtube') {
          title = 'ハッシュタグ名'
        } else {
          title = '動画タグ名'
        }
        break
      case 'characterNumber':
        title = '文字数レンジ'
        break
      case 'videoDuration':
        title = '動画秒数'
        break
    }

    return title
  }

  /**
   * convertPostType 投稿タイプをセット
   * @param {string} type 投稿タイプ
   * @return {string} 投稿タイプ
   */
  function convertPostType(type: string) {
    let typeValue = ''

    switch (type) {
      case 'テキスト':
        typeValue = 'text'
        break

      case '画像':
        typeValue = 'photo'
        break

      case 'リンク':
        typeValue = 'link'
        break

      case 'ビデオ':
        typeValue = 'video'
        break

      case 'ライブビデオ':
        typeValue = 'live-video'
        break

      case '360°ビデオ':
        typeValue = '360-video'
        break

      case 'カルーセル':
        typeValue = 'carousel'
        break

      case 'アルバム':
        typeValue = 'album'
        break

      case 'アニメーションGIF':
        typeValue = 'animation-gif'
        break

      case 'クーポン':
        typeValue = 'offer'
        break

      case 'ノート':
        typeValue = 'note'
        break

      case 'キャンバス':
        typeValue = 'rich_media'
        break
    }

    return typeValue
  }

  /**
   * convertCharacterNumber 文字数をセット
   * @param {string} characterNumber 文字数
   * @return {string} 文字数
   */
  function convertCharacterNumber(characterNumber: string) {
    let characterNumberValue = ''

    switch (characterNumber) {
      case '1,000文字以上':
        characterNumberValue = '1000'
        break

      case '500文字以上 - 1000文字未':
        characterNumberValue = '500-999'
        break

      case '200文字以上 - 500文字未満':
        characterNumberValue = '200-499'
        break

      case '100文字以上 - 200文字未満':
        characterNumberValue = '100-199'
        break

      case '50文字以上 - 100文字未満':
        characterNumberValue = '50-99'
        break

      case '10文字以上 - 50文字未満':
        characterNumberValue = '10-49'
        break

      case '10文字未満':
        characterNumberValue = '0-9'
        break
    }

    return characterNumberValue
  }

  /**
   * 動画秒数文字を動画範囲に変換
   * @param {string} videoDuration 動画秒数文字
   * @returns {string} 動画範囲
   */
  function convertVideoDuration(videoDuration: string) {
    let durationRange = ''

    switch (videoDuration) {
      case '5分以上':
        durationRange = '300'
        break

      case '3分 - 5分':
        durationRange = '180-299'
        break

      case '1分 - 3分':
        durationRange = '60-179'
        break

      case '30秒 - 1分':
        durationRange = '30-59'
        break

      case '30秒未満':
        durationRange = '0-29'
        break
    }

    return durationRange
  }

  return {
    setTargetTitle: setTargetTitle,
    convertPostType: convertPostType,
    convertCharacterNumber: convertCharacterNumber,
    convertVideoDuration: convertVideoDuration,
  }
}

/**
 * AccountDetailTableService アカウントの対象情報表示機能関連のサービスを1つのサービスにオブジェクトとして格納
 * @param {Function} AccountTargetData アカウントの対象情報の取得に関するService
 * @return {Object} サービスのオブジェクト
 */
function AccountTargetService(AccountTargetData) {
  return {
    Data: AccountTargetData,
  }
}

// アカウントの対象情報表示用のサービスを定義
app
  .factory('AccountTargetService', AccountTargetService)
  .factory('AccountTargetData', AccountTargetData)
